/**
  Copyright (c) [2022]
  Permission is hereby granted, free of charge, to any person obtaining a copy
  of this software and associated documentation files (the "Software"), to deal
  in the Software without restriction, including without limitation the rights
  to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
  copies of the Software, and to permit persons to whom the Software is
  furnished to do so, subject to the following conditions:

  The above copyright notice and this permission notice shall be included in all
  copies or substantial portions of the Software.

  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
  IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
  FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
  AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
  LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
  OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
  SOFTWARE.
*/

// Vue Imports
import { defineComponent } from 'vue';
// store
import { mapState, mapActions } from 'vuex';
// Components Imports
import HeaderDashboard from '@/components/header/header.vue';
import FooterDashboard from '@/components/footer/footer.vue';
// Third party components
import moment from 'moment';
import VueElementLoading from 'vue-element-loading';
import { useNotificationStore } from '@dafcoe/vue-notification';
// Service Imports
import EventService from '@/services/event';
import QRScanner from '@/views/QRScanner/QRScanner.vue';
// Router Imports
import router from '@/router';
// Defining Component
export default defineComponent({
  data() {
    return {
      qlist: [],
      showOwnerModel: false,
      userEmail: '',
      ownershipType: 'Admin',
      tickRecord: null,
      reissuemodal: false,
      uName: '',
      uEmail: '',
      quantity: 1,
      showModel1: false,
      infoModal: {
        '7Ht1OtomiNNpAq': {
          title: 'Scans By Food Vendors',
          buttonTitle: 'Export Vendor Details',
        },
      },
      showQRModal: false,
      showModal: false,
      list: [],
      sales: [],
      foodVendors: [],
      donationList: [],
      isloading: true,
      loadStyle: {
        color: '#ffffff',
        'font-weight': 'bold',
        'letter-spacing': '1rem',
        'font-size': '18px',
      },
    };
  },
  components: {
    HeaderDashboard,
    FooterDashboard,
    QRScanner,
    'vue-element-loading': VueElementLoading,
  },
  methods: {
    ...mapActions('events', ['setSelectedEvent', 'setRecentOrderPayload']),
    addOwner() {
      this.userEmail = '';
      this.ownershipType = 'Admin';
      this.showOwnerModel = true;
    },
    showQRModalPopup() {
      this.showQRModal = true;
    },
    closem1() {
      this.showOwnerModel = false;
    },
    openm(r: any, ev: any) {
      ev.stopPropagation();
      this.tickRecord = r;
      this.qlist = [];
      for (
        let k = 0;
        k <
        (r.availableTickets > r.allowedPerRequest
          ? r.allowedPerRequest
          : r.availableTickets);
        k++
      ) {
        (this.qlist as any).push(k + 1);
      }
      this.reissuemodal = true;
    },
    submitm() {
      this.isloading = true;
      let user: any = localStorage.getItem('user');
      if (user) {
        user = JSON.parse(user);
        EventService.cTicket({
          userName: this.uName,
          userEmail: this.uEmail,
          ticketId: (this.tickRecord as any).ticketCode,
          quantity: this.quantity,
        })
          .then((response) => {
            this.closem();
            const { setNotification } = useNotificationStore();
            setNotification({
              message: response.Message,
              type: 'success',
              showIcon: false,
            });
            location.reload();
          })
          .catch((err) => {
            this.closem();
            const { setNotification } = useNotificationStore();
            setNotification({
              message:
                err.response && err.response.data && err.response.data.Message
                  ? err.response.data.Message
                  : 'Something went wrong',
              type: 'error',
              showIcon: false,
            });
          })
          .finally(() => {
            this.isloading = false;
          });
      }
    },
    close1() {
      this.tickRecord = null;
      this.showModel1 = false;
    },
    waitingList() {
      router.push('/waitinglist');
    },
    open(tickRecord: any) {
      this.tickRecord = tickRecord;
      this.showModel1 = true;
    },
    scanData(type: string) {
      let user: any = localStorage.getItem('user');
      if (user) {
        user = JSON.parse(user);
        EventService.attendeeReport({
          eventId: this.selectedEvent.eventCode,
          userId: user.userId,
          type: type,
        })
          .then((rrr) => {
            const { setNotification } = useNotificationStore();
            setNotification({
              message: rrr.Message,
              type: rrr.Status == 'Success' ? 'success' : 'error',
              showIcon: false,
            });
          })
          .catch((err) => {
            const { setNotification } = useNotificationStore();
            setNotification({
              message:
                err.response && err.response.data && err.response.data.Message
                  ? err.response.data.Message
                  : 'Something went wrong',
              type: 'error',
              showIcon: false,
            });
          });
      }
    },
    scanData1(type: string, tid: string, ev: any) {
      ev.stopPropagation();
      let user: any = localStorage.getItem('user');
      if (user) {
        user = JSON.parse(user);
        EventService.attendeeReport({
          eventId: this.selectedEvent.eventCode,
          userId: user.userId,
          type: type,
          ticketId: tid,
        })
          .then((rrr) => {
            const { setNotification } = useNotificationStore();
            setNotification({
              message: rrr.Message,
              type: rrr.Status == 'Success' ? 'success' : 'error',
              showIcon: false,
            });
          })
          .catch((err) => {
            const { setNotification } = useNotificationStore();
            setNotification({
              message:
                err.response && err.response.data && err.response.data.Message
                  ? err.response.data.Message
                  : 'Something went wrong',
              type: 'error',
              showIcon: false,
            });
          });
      }
    },
    navigateto() {
      this.setRecentOrderPayload({
        eventId: this.selectedEvent.eventCode,
        page: 1,
        ticketId: '',
        type: 'ALL',
      });
      router.push('/orders');
    },
    closeQRModal() {
      this.showQRModal = false;
    },
    closem() {
      this.reissuemodal = false;
      this.uName = '';
      this.uEmail = '';
      this.quantity = 1;
    },
    invalidTicketEmail() {
      return /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/.test(
        this.uEmail
      );
    },
    exportfood() {
      let user: any = localStorage.getItem('user');
      if (user) {
        user = JSON.parse(user);
        EventService.exportFood({
          eventId: this.selectedEvent.eventCode,
          userId: user.userId,
        })
          .then((response) => {
            const { setNotification } = useNotificationStore();
            setNotification({
              message: response.Message,
              type: 'success',
              showIcon: false,
            });
          })
          .catch((err) => {
            const { setNotification } = useNotificationStore();
            setNotification({
              message:
                err.response && err.response.data && err.response.data.Message
                  ? err.response.data.Message
                  : 'Something went wrong',
              type: 'error',
              showIcon: false,
            });
          });
      }
    },
    export() {
      let user: any = localStorage.getItem('user');
      if (user) {
        user = JSON.parse(user);
        EventService.exportOrder({
          eventId: this.selectedEvent.eventCode,
          userId: user.userId,
        })
          .then((response) => {
            const { setNotification } = useNotificationStore();
            setNotification({
              message: response.Message,
              type: 'success',
              showIcon: false,
            });
          })
          .catch((err) => {
            const { setNotification } = useNotificationStore();
            setNotification({
              message:
                err.response && err.response.data && err.response.data.Message
                  ? err.response.data.Message
                  : 'Something went wrong',
              type: 'error',
              showIcon: false,
            });
          });
      }
    },
    close() {
      const self = this;
      self.showModal = false;
    },
    addOwners() {
      const self = this;
      const { setNotification } = useNotificationStore();
      let user = localStorage.getItem('user');
      let parseduser = {};
      if (user) {
        parseduser = JSON.parse(user);
      }
      if (!parseduser || !this.selectedEvent || !this.selectedEvent.eventCode) {
        return;
      }
      self.isloading = true;
      EventService.addOwner({
        eventId: this.selectedEvent.eventCode,
        userEmail: this.userEmail,
        ownershipType: this.ownershipType.toUpperCase(),
      })
        .then((r: any) => {
          if (r && r.Message) {
            setNotification({
              message: r.Message,
              type: 'success',
              showIcon: false,
            });
          }
          self.showOwnerModel = false;
        })
        .catch((error: any) => {
          if (
            error.response &&
            error.response.data &&
            error.response.data.Message
          ) {
            setNotification({
              message: error.response.data.Message,
              type: 'alert',
              showIcon: false,
            });
          } else {
            setNotification({
              message: 'Addition Failed',
              type: 'alert',
              showIcon: false,
            });
          }
        })
        .finally(() => {
          self.isloading = false;
        });
    },
    getPay() {
      const self = this;
      const { setNotification } = useNotificationStore();
      let user = localStorage.getItem('user');
      let parseduser = {};
      if (user) {
        parseduser = JSON.parse(user);
      }

      if (!parseduser || !this.selectedEvent || !this.selectedEvent.eventCode) {
        return;
      }
      self.isloading = true;
      EventService.getPayment({
        eventId: this.selectedEvent.eventCode,
        userId: (parseduser as any).userId,
      })
        .then((response: any) => {
          self.showModal = true;
        })
        .catch((error: any) => {
          if (
            error.response &&
            error.response.data &&
            error.response.data.Message
          ) {
            setNotification({
              message: error.response.data.Message,
              type: 'alert',
              showIcon: false,
            });
          } else {
            setNotification({
              message: 'Login Failed',
              type: 'alert',
              showIcon: false,
            });
          }
        })
        .finally(() => {
          self.isloading = false;
        });
    },
    isBefore(dateStr: string) {
      const isbefor = moment(dateStr).isBefore(new Date().toString());
      return isbefor ? 'Ended' : 'Available';
    },
    getDate(date: string) {
      return moment(date).format('MMM DD, YYYY');
    },
    removeunderscore(text: string) {
      const data = text.replaceAll('_', ' ').toLowerCase().split(' ');
      for (let i = 0; i < data.length; i++) {
        data[i] = data[i][0].toUpperCase() + data[i].substr(1);
      }
      return data.join(' ');
    },
    getTime(date: string) {
      return moment(date).format('hh:mm A');
    },
    navigateToOrders(payload: any) {
      localStorage.setItem('record1', JSON.stringify(payload || {}));
      this.setRecentOrderPayload(payload);
      router.push('/orders');
    },
    currentUserPicure(imgStr: string) {
      const user = localStorage.getItem('user');

      if (user) {
        const parseduser = JSON.parse(user);
        return (
          'https://storage.googleapis.com/s8w80ukr9zgzqst5era7u9uh1eo5uf81kibwqdsu6j4f1mh7tw/' +
          imgStr
        );
      }

      return null;
    },
  },
  computed: {
    ...mapState('events', ['selectedEvent', 'recentOrderPayload']),
    invalidEmail() {
      return /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/.test(
        this.userEmail
      );
    },
    getDetails() {
      let rr: any = localStorage.getItem('record');
      if (rr) {
        rr = JSON.parse(rr) as any;
        this.setSelectedEvent(rr);
      }

      if (
        rr &&
        rr.eventOwners &&
        rr.eventOwners[0] &&
        rr.eventOwners[0].ownershipType
      ) {
        return rr.eventOwners[0].ownershipType;
      }
      return '';
    },
  },
  created() {
    localStorage.removeItem('record1');
    if (!this.selectedEvent) {
      let rr = localStorage.getItem('record');
      if (rr) {
        rr = JSON.parse(rr);
        this.setSelectedEvent(rr);
      }
    }
  },
  mounted() {
    window.scrollTo(0, 0);
    if (!this.selectedEvent) {
      router.push('/events');
      return;
    }

    if (
      this.selectedEvent.foodVendors &&
      this.selectedEvent.foodVendors.length > 0
    ) {
      this.foodVendors = this.selectedEvent.foodVendors;
    }

    this.sales = this.selectedEvent.freePaidTickets || [];
    this.donationList = this.selectedEvent.donationTickets || [];
    this.isloading = true;

    let rrr: any = localStorage.getItem('record');
    if (rrr) {
      try {
        rrr = JSON.parse(rrr);
        EventService.paginatedEventDetail({
          eventId: rrr.eventCode,
        })
          .then((responss: any) => {
            this.setSelectedEvent(responss.Result);
            this.sales = responss.Result.freePaidTickets || [];
            this.donationList = responss.Result.donationTickets || [];
          })
          .finally(() => {
            this.isloading = false;
            console.log(this.sales);
          });
      } catch (e) {}
    }

    EventService.fetchRecentOrders({
      eventId: this.selectedEvent.eventCode,
      ticketId: '',
      type: 'RECENT',
      page: 1,
    })
      .then((response: any) => {
        if (response.Result && response.Result.data) {
          this.list = response.Result.data;
        }

        //  this.isloading = false;
      })
      .catch((err: any) => {
        //  this.isloading = false;
      });
  },
});
